// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3W0uo","content":"ManualTimeModal_content__3E-to"};